import config from './config'

const API_BASE = () => (config.baseURL || '').replace(/\/$/, '')
const MP_STATIC_ORIGIN = 'https://zmuse.cn'

/** mp-weixin 大图走 CDN；H5 仍用本地 /static */
export function remoteStaticUrl(url) {
  if (url == null) return ''
  const u = String(url).trim()
  if (!u) return ''
  if (/^https?:\/\//i.test(u)) return u
  // #ifdef MP-WEIXIN
  if (u.startsWith('/static')) return MP_STATIC_ORIGIN + u
  if (u.startsWith('static/')) return `${MP_STATIC_ORIGIN}/${u}`
  // #endif
  return u.startsWith('/') ? u : `/${u}`
}

/**
 * 将接口返回的图片路径转为当前环境可访问的完整 URL。
 * - /profile/* 走后端静态资源（与 API 同域，国内部署无墙问题）
 * - /static/* 走 uni-app 本地静态资源
 * - 历史数据中的 localhost 会改写到当前 VITE_APP_BASE_URL
 */
export function resolveMediaUrl(url) {
  if (url == null) return ''
  const u = String(url).trim()
  if (!u) return ''

  if (/^https?:\/\//i.test(u)) {
    const m = u.match(/^https?:\/\/(?:localhost|127\.0\.0\.1)(?::\d+)?(\/.*)$/i)
    if (m) {
      const base = API_BASE()
      return base ? base + m[1] : m[1]
    }
    return u
  }

  if (u.startsWith('/profile') || u.startsWith('/upload')) {
    // H5 开发走 Vite 同源代理，避免跨域导致 image 加载失败
    if (import.meta.env.DEV && typeof window !== 'undefined') {
      return u
    }
    const base = API_BASE()
    return base ? base + u : u
  }

  if (u.startsWith('/static') || u.startsWith('static/')) {
    return remoteStaticUrl(u)
  }

  return u
}

const MEDIA_KEYS = new Set([
  'bannerImg',
  'packImg',
  'cardImg',
  'productImg',
  'activityImg',
  'categoryImg',
  'image',
  'avatar',
  'banner_img',
  'pack_img',
  'card_img',
  'product_img',
  'activity_img',
  'category_img',
])

export function resolveMediaInData(data) {
  if (data == null) return data
  if (Array.isArray(data)) {
    return data.map((item) => resolveMediaInData(item))
  }
  if (typeof data !== 'object') return data

  const out = { ...data }
  for (const key of Object.keys(out)) {
    const val = out[key]
    if (MEDIA_KEYS.has(key) && typeof val === 'string') {
      out[key] = resolveMediaUrl(val)
    } else if (val && typeof val === 'object') {
      out[key] = resolveMediaInData(val)
    }
  }
  return out
}
